//@ts-ignore
import {
  TutorVideoIntroduction,
  TutorVideoIntroductionProps,
} from "@tuteria/shared-lib/src/_new_/features/tutor-video-introduction/TutorVideoIntro";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

export function unMountLoadTutorVideoIntro(id: string) {
  ReactDOM.unmountComponentAtNode(document.getElementById(id));
}

const Component = ({
  handleClosingModal,
  updateVideoStatus,
  getVideoDetails,
}: TutorVideoIntroductionProps) => {
  return (
    <TutorVideoIntroduction
      getVideoDetails={getVideoDetails}
      updateVideoStatus={updateVideoStatus}
      handleClosingModal={handleClosingModal}
    />
  );
};

type Payload = {
  email: string;
};

export function loadTutorVideoIntro(
  payload: Payload,
  id: string,
  urls: {},
  callback: (...args: any[]) => void
) {
  const {} = payload;

  function onClose() {
    unMountLoadTutorVideoIntro(id);
  }

  async function getVideoDetails() {
    try {
      const response = await fetch(`/new-subject-flow/login`, {
        method: "post",
        body: JSON.stringify({
          email: payload.email,
          is_admin: true,
          auto_login: true,
        }),
      });
      if (response.ok) {
        let { data } = await response.json();
        console.log("data", data);
        // return { verified: data.personalInfo.videoIntroVerified, url: data.personalInfo.videoIntro };
        return {
          verified: true,
          url: "https://www.youtube.com/watch?v=R1dAa8neDRw",
        };
      }

      throw new Error("Error fetching user with passed id");
    } catch (e) {
      throw e;
    }
  }

  async function updateVideoStatus(action: "approve" | "reject") {
    try {
      const response = await fetch(`/admin/tutors/update-video-state`, {
        method: "post",
        body: JSON.stringify({
          email: payload.email,
          action,
        }),
      });
      if (response.ok) {
        return `Video ${action}${
          action === "reject" ? "ed" : "d"
        } successfully`;
      }

      throw new Error("Error fetching user with passed id");
    } catch (e) {
      throw e;
    }
  }

  ReactDOM.render(
    <ThemeProvider>
      <Component
        {...{
          handleClosingModal: onClose,
          getVideoDetails,
          updateVideoStatus,
        }}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
